var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2515 18.7853H20.953C17.7876 18.7853 14.6249 18.7853 11.4595 18.7853C10.8242 18.7853 10.3204 18.4828 10.1013 17.9796C9.88226 17.4739 10.0246 16.9101 10.4682 16.5424C10.753 16.3052 11.098 16.2157 11.4841 16.2157C13.5515 16.2181 15.6162 16.2157 17.6836 16.2157C18.7816 16.2157 19.8796 16.2157 20.9777 16.2157H21.246C21.0133 15.998 20.8189 15.8165 20.6217 15.635C20.1151 15.1656 19.6058 14.6986 19.0992 14.2293C18.7077 13.8663 18.5707 13.4381 18.7077 12.9541C18.8391 12.492 19.1704 12.1751 19.6962 12.0468C20.2274 11.9186 20.6847 12.0589 21.0598 12.4049C22.1332 13.3945 23.2039 14.3865 24.2773 15.3785C24.7154 15.785 25.1563 16.1915 25.5916 16.598C26.1311 17.1037 26.1393 17.8683 25.5971 18.374C24.1048 19.7676 22.6042 21.1589 21.1091 22.5501C20.5231 23.0945 19.7345 23.1502 19.1485 22.688C18.5653 22.2283 18.4886 21.4105 19.0061 20.8782C19.3758 20.4983 19.7811 20.1475 20.1726 19.7821C20.5177 19.4628 20.8627 19.1458 21.2542 18.7829L21.2515 18.7853Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.977e7a48e3547720450c4862de6b406d.svg";
export { ForwardRef as ReactComponent };